// ----------------------------------------------------------------------------
// Component: Search
// ----------------------------------------------------------------------------
//
//
// ----------------------------------------------------------------------------

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _ = require('lodash');

// Constant elements
var SEARCH_BOX           = '.search-box';
var SEARCH_INPUT         = '.search-box__input';
var FORM_INPUT           = '.form__field--input';
var SEARCH_LABEL         = '.form__label';
var HEADER               = '.header__wrapper';

module.exports = function() {

    $.fn.clickOff = function(callback, selfDestroy) {
        var clicked = false;
        var parent = this;
        var destroy = selfDestroy || true;

        parent.click(function() {
            clicked = true;
        });

        $(document).click(function(event) {
            if (!clicked) {
                callback(parent, event);
            }
            // if (destroy) {
            // };
            clicked = false;
        });
    };

    /**
     * clickOff: Collapse an active search box
     *
     * @param {Event} e
     * @return void
     */
    $(SEARCH_BOX).clickOff(function(e) {
        $input = $(SEARCH_INPUT);
        $header = $(HEADER);

        $input.removeClass('is-active');
        $header.removeClass('is-open');
    });

    $(document).on('click', SEARCH_BOX, _.bind(search_box.click, search_box));
};

var search_box = {
    /**
     * click: Open up an inactive search box to allow input entry
     *
     * @param {Event} e
     * @return void
     */
    click: function(e) {
        var $this = $(e.target);

        $form = $this.closest(SEARCH_BOX);
        $input = $form.find(SEARCH_INPUT);
        $header = $(HEADER);

        $input.addClass('is-active');
        $form.addClass('is-active');
        $input.focus();
        $header.addClass('is-open');
    }

};
